import { FormControlLabel, FormLabel, Grid, RadioGroup } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import { goBack, push } from "redux-first-history";
import CustomButton from "../../../components/CustomButton";
import CustomRadio from "../../../components/CustomRadio";
import FormLayout from "../../../components/FormLayout";
import { userSlice } from "../../../store/reducer/user";
import { userSetupSlice } from "../../../store/reducer/user_setup";
import AccessibleFormControlLabel from "./AccessibleFormControlLabel";

// The user model isn't being passed in here, but the user.data Redux store
const AdditionalTaxInfo = ({ dispatch, user }: any) => {
  const _formData = {
    personalInfo: {
      filedScheduleE: user.is_sch_e_filed ?? false,
      filedBusinessSale: user.is_business_sale_filed ?? false,
    },
  };

  const _setFormData = (formData: any) => {
    dispatch(userSlice.actions.updateUserData({
      is_sch_e_filed: formData.personalInfo.filedScheduleE,
      is_business_sale_filed: formData.personalInfo.filedBusinessSale,
    }));
  }

  return (
    <FormLayout
      title="A Couple More Questions..."
      subtitle="Additional Tax Info"
      description={`The following filing situations are unusual, but we need to know if they apply to you before we get started.`}
    >
      <Grid container spacing={2} className='form-container xl'>
        <Grid className='radio-group-row' size={12}>
          <span className='radio-group-label'>
            {`Did you file a Schedule E with your Federal return to report rental,
            partnership, S-corp, or trust income?`}
          </span>
          <RadioGroup
            value={_formData.personalInfo.filedScheduleE}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              _setFormData({
                ..._formData,
                personalInfo: {
                  ..._formData.personalInfo,
                  // eslint-disable-next-line eqeqeq
                  filedScheduleE: e.target.value == "true",
                },
              });
            }}
          >
            <AccessibleFormControlLabel
              value={true}
              control={<CustomRadio />}
              label="Yes"
            />
            <AccessibleFormControlLabel
              tabIndex={0}
              value={false}
              control={<CustomRadio />}
              label="No"
            />
          </RadioGroup>
        </Grid>
        <Grid className='radio-group-row' size={12}>
          <span className='radio-group-label'>
            {`Did you report gains or losses from the sale of business property on Form 4797 of your
            Federal return?`}
          </span>
          <RadioGroup
            value={_formData.personalInfo.filedBusinessSale}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              _setFormData({
                ..._formData,
                personalInfo: {
                  ..._formData.personalInfo,
                  // eslint-disable-next-line eqeqeq
                  filedBusinessSale: e.target.value == "true",
                },
              });
            }}
          >
            <AccessibleFormControlLabel
              value={true}
              control={<CustomRadio />}
              label="Yes"
            />
            <AccessibleFormControlLabel
              value={false}
              control={<CustomRadio />}
              label="No"
            />
          </RadioGroup>
        </Grid>
      </Grid>
      <div className='btn-container'>
        <CustomButton
          variant="outlined"
          disableElevation={false}
          label={"back"}
          onClick={() => dispatch(push(user.is_jointfiling ? '/user/spouse-info' : '/user/personal-info'))}
          buttonSize='btn-lg'
        />
        <CustomButton
          variant="contained"
          disableElevation={true}
          label={"next"}
          type="submit"
          onClick={() => dispatch(userSetupSlice.actions.confirmStep())}
          buttonSize="btn-lg"
        />
      </div>
    </FormLayout>
  );
};

const mapStateToProps = (state: any) => ({
  user: state.user.data,
});

export default connect(mapStateToProps)(AdditionalTaxInfo);
